import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedeempopupComponent } from './redeempopup.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
      path: '',
      component: RedeempopupComponent,
      data: {
          title: 'Redeem Popup'
      }
  }
];
@NgModule({
  declarations: [RedeempopupComponent],
  imports: [
    CommonModule, 
    BrowserModule, 
    ReactiveFormsModule,  
    FormsModule,   
    MatDialogModule,
    NgbModule, 
    RouterModule.forChild(routes)
  ]
})
export class RedeempopupModule { }
